import ApolloWrapper from '@/features/graphql/components/ApolloWrapper'
import OpenTabsDataProvider from '@/features/openTabs/contexts/OpenTabsData'
import ConfigurableProductIdProvider from '@/features/pos/contexts/ConfigurableProductId'
import { Stack } from 'expo-router'
import { FC } from 'react'

const Layout: FC = () => (
    <ApolloWrapper channel="tab">
        <ConfigurableProductIdProvider>
            <OpenTabsDataProvider>
                <Stack screenOptions={{ headerShown: false }}>
                    <Stack.Screen name="index" />
                    <Stack.Screen name="split" />
                    <Stack.Screen name="payment" />
                </Stack>
            </OpenTabsDataProvider>
        </ConfigurableProductIdProvider>
    </ApolloWrapper>
)

export default Layout
